import {getMessaging, getToken, isSupported} from 'firebase/messaging';

import {API, ApiEndpointsEnum} from '../server/api';
import {FCM_WEB_VAPID_KEY} from '../server/api/api.config';

export const registerAdminPwaPushAfterUserAction = () => {
  let disposed = false;

  if (!('Notification' in window)) {
    return () => undefined;
  }

  const registerAdminPush = async () => {
    if (
      disposed ||
      !('serviceWorker' in navigator) ||
      !(await isSupported())
    ) {
      return;
    }

    const permission =
      Notification.permission === 'default'
        ? await Notification.requestPermission()
        : Notification.permission;
    if (permission !== 'granted' || disposed) {
      return;
    }

    const registration = await navigator.serviceWorker.register(
      '/firebase-messaging-sw.js',
    );
    const token = await getToken(getMessaging(), {
      serviceWorkerRegistration: registration,
      vapidKey: FCM_WEB_VAPID_KEY,
    });

    if (token && !disposed) {
      const aguid = require('aguid');
      await API.post(ApiEndpointsEnum.POST_FIREBASE_TOKEN, {
        deviceId: aguid(navigator.userAgent),
        token,
      });
    }
  };

  const registerAfterUserAction = () => {
    registerAdminPush().catch(error => {
      console.warn('Unable to enable admin PWA push updates:', error);
    });
  };

  if (Notification.permission === 'granted') {
    registerAfterUserAction();
  } else {
    window.addEventListener('pointerdown', registerAfterUserAction, {
      once: true,
    });
  }

  return () => {
    disposed = true;
    window.removeEventListener('pointerdown', registerAfterUserAction);
  };
};
